import { render, staticRenderFns } from "./AsideEventComponent.vue?vue&type=template&id=946b5918"
import script from "./AsideEventComponent.vue?vue&type=script&lang=js"
export * from "./AsideEventComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports